<section class="auto-ship-products" *ngIf="vm$ | async as vm">
  <nav class="auto-ship-navigation" [attr.aria-label]="'autoShip.products.navigationLabel' | cxTranslate">
    <span class="auto-ship-navigation__item auto-ship-navigation__item--active" aria-current="page">
      {{ 'autoShip.products.partsSelectionTab' | cxTranslate }}
    </span>

    <span class="auto-ship-navigation__item">
      {{ 'autoShip.schedule.shipmentScheduleTab' | cxTranslate }}
    </span>
  </nav>

  <h1 class="title">{{ 'autoShip.products.title' | cxTranslate }}</h1>

  <cx-spinner *ngIf="vm.loading" class="page-spinner"></cx-spinner>

  <div class="auto-ship-layout">
    <div class="results">
      <p *ngIf="vm.error" class="alert alert-danger">{{ 'autoShip.products.loadError' | cxTranslate }}</p>

      <gen-auto-ship-product-scroll [model]="vm.model" [netPrices]="vm.netPrices"
        [netPricesLoading]="vm.netPricesLoading" [quantities]="vm.cartQuantities"
        (visible)="onViewportVisible()" (quantityChange)="onQuantityChange($event)"></gen-auto-ship-product-scroll>

      <button type="button" class="btn btn-primary auto-ship-add-to-cart" (click)="addToCart()"
        [disabled]="addToCartDisabled$ | async">
        {{ 'autoShip.products.addToCart' | cxTranslate }}
      </button>

      <div class="pagination" *ngIf="!vm.loading && (vm.model?.pagination?.totalPages ?? 0) > 1">
        <cx-pagination [pagination]="vm.model?.pagination" [defaultPage]="0"
          (viewPageEvent)="changePage($event)"></cx-pagination>
      </div>
    </div>
  </div>
</section>
